import { useSearchParams, Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { useEffect } from "react";

const OrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");

  // ✅ Clear cart so App.js initializes with empty cart
  useEffect(() => {
    localStorage.removeItem("cart");
  }, []);

  return (
    <Box sx={{ textAlign: "center", py: 10 }}>
      <AppBar position="static" color="primary">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" fontWeight={600}>
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>

      <Typography
        variant="h3"
        color="success.main"
        gutterBottom
        sx={{ mt: 6 }}
      >
        ✅ Payment Successful!
      </Typography>

      <Typography variant="h6" gutterBottom>
        Your payment for order #{orderId} was successful.
      </Typography>

      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
      >
        Back to Store
      </Button>
    </Box>
  );
};

export default OrderSuccess;
